import { createContext, useState } from "react";
import { createFormConfig } from "../utils/formFactory";

export const FormContext = createContext({
    formData: {},
    updateFormdata: () => {},
    setInitialFormdata: () => {},
    formType: null,
    setFormType: () => {},
    isFormOpen: false,
    setIsFormOpen: () => {}
});

export const FormProvider = ({children}) => {
    const [formData, setFormData] = useState({});
    const [ formType, setFormType ] = useState();
    const [ isFormOpen, setIsFormOpen ] = useState(false);
    const [destinationId, setDestinationId] = useState();
    const [adventureId, setAdventureId] = useState();

    const setInitialFormdata = (formType, initialValues = {}) => {
        const { fields, groupedFields = []} = createFormConfig(formType);
        setFormData({
        ...fields.reduce((acc, field) => ({ ...acc, [field.name]: initialValues[field.name] || (initialValues[field.name] === false ? false : "") }), {}),
        ...groupedFields.reduce(
            (acc, field) => ({ ...acc, [field.name]: initialValues[field.name] || field.defaultValue || [] }),
            {}
        ),
        });
    }

    const updateFormdata = (data) => {
        setFormData(data)
    }

    const updateDestinationId = (id) => {
      setDestinationId(id);
    };

    const updateAdventureId = (id) => {
      setAdventureId(id);
    };

    const value = {formData, updateFormdata, updateDestinationId, destinationId, updateAdventureId, adventureId, setInitialFormdata, isFormOpen, setIsFormOpen, setFormType, formType}

    return <FormContext.Provider value={value}>{ children }</FormContext.Provider>
}